import { API } from '../api'
import { UnitsResponse } from './interface'

export const download = async (
  collectId: string
): Promise<{
  conteudo: string
  sucesso: boolean
  erro?: string
}> => {
  try {
    const response = await API.post<UnitsResponse>(
      `/logistica/agrupamento/obter-itens-para-vinculo/${collectId}`
    )

    return {
      conteudo: response.content,
      sucesso: response.isSuccess
    }
  } catch (error) {
    console.error('Erro ao baixar planilhas:', error)
    return {
      conteudo: null,
      sucesso: false,
      erro: error
    }
  }
}
